import { ComponentProps, FC } from 'react';

import { Icon } from './Icon';

export const IconTransparentRates: FC<ComponentProps<typeof Icon>> = (props) => (
  <Icon {...props} viewBox="0 0 40 40">
    <g id="Transparent rates">
      <g id="icon">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M30.708 22.375A11.618 11.618 0 0 1 23.334 25c-6.443 0-11.667-5.223-11.667-11.666 0-6.444 5.224-11.667 11.667-11.667S35 6.89 35 13.334c0 2.926-1.077 5.6-2.856 7.648l3.704 3.704c.313.313.25.883-.14 1.274-.39.39-.961.453-1.274.14l-3.726-3.725zm2.293-9.041C33 18.672 28.674 23 23.335 23s-9.667-4.328-9.667-9.666a9.667 9.667 0 0 1 9.667-9.667A9.667 9.667 0 0 1 33 13.334z"
          fill="#150D2C"
          fillOpacity="0.878431"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.79 8.877a1 1 0 0 1 0 1.414l-7.5 7.5a1 1 0 0 1-1.414-1.413l7.5-7.5a1 1 0 0 1 1.415 0z"
          fill="#150D2C"
          fillOpacity="0.878431"
        />
        <path
          d="M22.084 10.209a1.875 1.875 0 1 1-3.75-.001 1.875 1.875 0 0 1 3.75-.001z"
          fill="#150D2C"
          fillOpacity="0.878431"
        />
        <path
          d="M28.334 16.459a1.875 1.875 0 1 1-3.75-.001 1.875 1.875 0 0 1 3.75-.001z"
          fill="#150D2C"
          fillOpacity="0.878431"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 8.334a2.667 2.667 0 0 1 2.667-2.667h5v2h-5A.667.667 0 0 0 6 8.334v25c0 .368.299.666.667.666h16.667a.667.667 0 0 0 .666-.666v-6.667h2v6.667A2.667 2.667 0 0 1 23.334 36H6.667A2.667 2.667 0 0 1 4 33.334v-25z"
          fill="#150D2C"
          fillOpacity="0.878431"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M20 31h-6.666v-2H20v2z" fill="#150D2C" fillOpacity="0.878431" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.667 26H8.334v-2h3.333v2z"
          fill="#150D2C"
          fillOpacity="0.878431"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.667 31H8.334v-2h3.333v2z"
          fill="#150D2C"
          fillOpacity="0.878431"
        />
      </g>
    </g>
  </Icon>
);
